import { render, staticRenderFns } from "./CoapServerFields.vue?vue&type=template&id=200abc8a&"
import script from "./CoapServerFields.vue?vue&type=script&lang=ts&"
export * from "./CoapServerFields.vue?vue&type=script&lang=ts&"


/* normalize component */
import normalizer from "!../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports